export enum Status {
  Active = "Active",
  InActive = "InActive",
}

export type DataState = (typeof Status)[keyof typeof Status];
